import React from 'react'
import { useSearchParams } from 'react-router-dom';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();

  const ref = searchParams.get("ref");
  const txn = searchParams.get("txn");

  return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center px-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <div className="text-green-500 text-6xl mb-4">✓</div>
        <h2 className="text-3xl font-bold text-gray-800 mb-2">Payment Successful!</h2>
        <p className="text-gray-600 mb-6">Your payment has been processed successfully.</p>
        
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-gray-700">
              <span className="font-medium">Reference:</span><br />
              <span className="font-mono text-xs">{ref}</span>
            </p>
            <p className="text-sm text-gray-700">
              <span className="font-medium">Transaction ID:</span><br />
              <span className="font-mono text-xs">{txn}</span>
            </p>
          </div>
        
      </div>
    </div>
  )
}

export default PaymentSuccess